<edu-card>
  <div class="flex flex-col items-center space-y-6 p-8 text-center">
    <!-- Error Icon -->
    <div class="bg-danger/10 flex h-20 w-20 items-center justify-center rounded-full">
      <edu-icon [icon]="WarningIcon" iconClasses="text-4xl text-danger" />
    </div>

    <!-- Error Title -->
    <div class="space-y-2">
      <h1
        class="text-fg text-2xl font-bold"
        [innerHTML]="header() || ('shared.compound.generalError.title' | transloco)"
      ></h1>
      <p
        class="text-fg-muted m-auto max-w-md"
        [innerHTML]="description() || ('shared.compound.generalError.description' | transloco)"
      ></p>
    </div>

    <!-- Action Buttons -->
    <div class="flex w-full items-center justify-center gap-4">
      @if (isGoBackButtonVisible()) {
        <edu-button variant="secondary" size="md" (press)="goBack()">
          {{ 'shared.compound.generalError.goBack' | transloco }}
        </edu-button>
      }
      <edu-button variant="primary" size="md" (press)="goToHomepage()">
        {{ 'shared.compound.generalError.goHome' | transloco }}
      </edu-button>
    </div>

    <!-- Support Link -->
    <div class="text-fg-muted text-sm">
      {{ 'shared.compound.generalError.supportText' | transloco }}
      <a
        href="https://edudip.com/kontakt"
        target="_blank"
        class="text-primary hover:text-primary-hover underline"
      >
        {{ 'shared.compound.generalError.contactSupport' | transloco }}
      </a>
    </div>
  </div>
</edu-card>
